import { SKUDTO } from './SKUDTO'

export class ModifierDTO {
    constructor(
        public id: string,
        public displayName: string,
        public description: string | null,
        public skus: SKUDTO[],
        public dateCreated: string,
        public dateUpdated: string
    ) { }
}

export class ModifierGroupDTO {
    constructor(
        public id: string,
        public name: string,
        public minimumModifiersRequired: number | null,
        public maximumModifiersRequired: number | null,
        public modifiers: ModifierDTO[],
        public dateCreated: string,
        public dateUpdated: string
    ) { }
}
